import { PlainSelect } from './PlainSelect';

export default PlainSelect;
